// extracted by mini-css-extract-plugin
module.exports = {"content":"NumberUnitField_content__39BG0","number":"NumberUnitField_number__2AnSU","numberField":"NumberUnitField_numberField__2pFNJ","unit":"NumberUnitField_unit__Q0Kie"};